





















































































































import {
  defineComponent,
  PropType,
  SetupContext,
} from '@nuxtjs/composition-api';
// @ts-ignore
// import Intersect from 'vue-intersect';
import {
  CorporationArea,
  CorporationOffice,
} from '~/graphql/graphqlOperations';
export default defineComponent({
  // components: { Intersect },
  props: {
    title: {
      type: String,
      default: null,
    },
    areas: {
      type: Array as PropType<CorporationArea[] | null>,
      default: null,
    },
    offices: {
      type: Array as PropType<CorporationOffice[] | null>,
      default: null,
    },
  },
  setup(props, _context: SetupContext) {
    const corporationAreas = props.areas || [
      { id: 0, name: '', offices: props.offices },
    ];

    // 個別に返却された画像を配列化
    const toImageArrays = (office: any) => {
      const result = [];
      if (office?.imageUrl) result.push({ id: '1', url: office.imageUrl });
      if (office?.imageUrl2) result.push({ id: '2', url: office.imageUrl2 });
      if (office?.imageUrl3) result.push({ id: '3', url: office.imageUrl3 });
      if (office?.imageUrl4) result.push({ id: '4', url: office.imageUrl4 });
      if (office?.imageUrl5) result.push({ id: '5', url: office.imageUrl5 });
      return result;
    };

    // const onEnter = (object: IntersectionObserverEntry[]) => {
    //   object[0].target.classList.remove('-darken');
    // };

    // const onLeave = (object: IntersectionObserverEntry[]) => {
    //   object[0].target.classList.add('-darken');
    // };

    // TODO: コールバックの書き方サンプルに残しとく
    const load_image_intersection_callback = (
      _isIntersecting: boolean,
      _el: HTMLElement,
      _options: any
    ) => {
      //   console.warn(isIntersecting);
      //   console.warn(el);
      //   console.warn(options);
    };
    return {
      load_image_intersection_callback,
      corporationAreas,
      toImageArrays,
      // onEnter,
      // onLeave,
    };
  },
});
